import CaseComponent from './components/case/CaseComponent';
import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <CaseComponent />
      <span style={{display:'none'}}>© BaoChn</span>
    </div>
  );
}

export default App;
